import LazyLoad from 'react-lazyload'
import Link from 'next/link'
import React from 'react'

const TemaCard = React.memo(({ tema }) => {
  const thumb = tema?.preview_image
    ? tema.preview_image
    : tema.main_image
    ? tema.main_image
    : '/images/demo/bg-bullismo.jpg'

  return (
    <article className="col col-sm-6 col-md-4 col-lg-3">
      <Link legacyBehavior href={tema.url}>
        <a className="temi-item">
          <LazyLoad height={380} offset={100} once>
            <img
              className="temi-item__image"
              src={thumb}
              alt={tema.titolo?.toAltTitle()}
              title={tema.titolo?.toAltTitle()}
            />
          </LazyLoad>
          <div className="temi-item__title">{tema.titolo}</div>
          <div className="temi-item__details">
            <div className="temi-item__details__title">{tema.titolo?.capitalize()}</div>
            <div className="temi-item__details__abstract">{tema.descrizione}</div>
          </div>
        </a>
      </Link>
    </article>
  )
})

export default TemaCard
